import { gql } from '@apollo/client';
import { GET_MY_PERMISSIONS as GET_MY_PERMISSIONS_QUERY } from '../../application/query/static/permissions';

const GET_PAGE_BUILDER_TEMPLATE = gql`
  query getActivePageBuilderTemplate($id: String!) {
    getActivePageBuilderTemplate(id: $id)
  }
`;

const GET_PAGE_BUILDER_CACHED_COMPONENTS = gql`
  query getPBComponents {
    components @client
  }
`;

const GET_EDITOR_VIEW_RECT = gql`
  query getEditorViewRect {
    rect @client
  }
`;

const GET_MY_PERMISSIONS = gql(GET_MY_PERMISSIONS_QUERY);

export {
  GET_PAGE_BUILDER_TEMPLATE,
  GET_PAGE_BUILDER_CACHED_COMPONENTS,
  GET_EDITOR_VIEW_RECT,
  GET_MY_PERMISSIONS
};
